import { ISearchPromosV2ResponseSchema } from '../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';

export const mapPath = (promosResponse: ISearchPromosV2ResponseSchema): string => {
  return promosResponse.path || '';
};
